import * as ng from 'angular';

import {Experience, ExperienceTypeID, experienceTypeDefs} from '../';
import {EditorModel} from './editor.model';
import '../type/app/app-editor.model';
import '../type/email/email-editor.model';
import '../type/passbook/passbook-editor.model';
import '../type/sms/sms-editor.model';
import '../type/qrcode/qrcode-editor.model';
import '../type/media/media-editor.model';
import '../type/rsvp/rsvp-editor.model';
import '../type/web-reg/web-reg-editor.model';
import '../type/join-virtual/join-virtual-editor.model';

export {EditorModel};

ng.module('e360')
   .factory('editorModelFactory', editorModelFactoryInjector);

editorModelFactoryInjector.$inject = [
   '$injector',
   'appEditorModelFactory',
   'emailEditorModelFactory',
   'passbookEditorModelFactory',
   'smsEditorModelFactory',
   'qrcodeEditorModelFactory',
   'mediaEditorModelFactory',
   'rsvpEditorModelFactory',
   'webregEditorModelFactory',
   'joinVirtualEditorModelFactory'
];
function editorModelFactoryInjector(
   $injector:ng.auto.IInjectorService,
   appEditorModelFactory,
   emailEditorModelFactory,
   passbookEditorModelFactory,
   smsEditorModelFactory,
   qrcodeEditorModelFactory,
   mediaEditorModelFactory,
   rsvpEditorModelFactory,
   webregEditorModelFactory,
   joinVirtualEditorModelFactory
) {
   return function editorModelFactory(typeSlug:string, campaign, experience:Experience) {
      EditorModel.$injector = $injector;

      let typeDef = experienceTypeDefs[typeSlug];
      let args = {
         campaign: campaign,
         typeDef: typeDef,
         experience: experience
      };

      if (typeDef.id == ExperienceTypeID.App) {
         return appEditorModelFactory(args);
      } else if (typeDef.id == ExperienceTypeID.Email) {
         return emailEditorModelFactory(args);
      } else if (typeDef.id == ExperienceTypeID.Passbook) {
         return passbookEditorModelFactory(args);
      } else if (typeDef.id == ExperienceTypeID.SMS) {
         return smsEditorModelFactory(args);
      } else if (typeDef.id == ExperienceTypeID.QRCode) {
         return qrcodeEditorModelFactory(args);
      } else if (typeDef.id == ExperienceTypeID.Media) {
         return mediaEditorModelFactory(args);
      } else if (typeDef.id == ExperienceTypeID.RSVP) {
         return rsvpEditorModelFactory(args);
      } else if (typeDef.id == ExperienceTypeID.WebReg) {
         return webregEditorModelFactory(args);
      } else if (typeDef.id == ExperienceTypeID.JoinVirtual) {
         return joinVirtualEditorModelFactory(args);
      } else {
         throw `Unsupported exerience slug '${typeSlug}'`;
      }
   }
}

export interface EditorModelFactory {
   (typeSlug:string, campaign, experience:Experience):EditorModel;
}
